// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__VKYmK","rotation":"Loading_rotation__FSNVt","loaderLight":"Loading_loaderLight__+4un+"};